import api from '../api'
import auth from '../token'

const station = auth.getStationNumber();

export default {

  getBackups(page = 0, word = '', idStation = null, date1, date2) {
    const role = localStorage.getItem('role')
    const params = {
      page: page,
      word: word,
      size: 5,
      order: 'desc',
      dateInit: date1 ? date1 : '',
      dateEnd: date2 ? date2 : ''
    }
    const pms = new URLSearchParams(params).toString()
    if (role === 'ADMIN' || role === 'SUPPORT') {
      if (idStation || idStation !== null) {
        return api.request('GET', '/backedFile/list/' + idStation + '?' + pms);
      } else {
        return api.request('GET', '/backedFile/list?' + pms);
      }
    } else {
      return api.request('GET', '/backedFile/list/' + station + '?' + pms);
    }
  },

  getFile(id) {
    return api.request('GET', '/backedFile/downloadfile/' + id);
  },

  sendBackupByEmail(data) {
    return api.request('POST', '/backedFile/sendEmail', data);
  }

}
